<template>
  <div class="studyPublish">
    <div class="studyPublish-title">出版</div>
    <div class="studyPublish-info">
      <div class="studyPublish-pre">
        <img class="studyPublish-pre-img" src="@/assets/HCZ1.jpg" alt="" />
        <div class="studyPublish-pre-info">出刊物规格：XXXX</div>
        <div class="studyPublish-pre-info">出刊物信息：XXXX</div>
      </div>
      <div class="studyPublish-content">
        <div class="studyPublish-content-title">出刊物名称：贾科梅蒂在塱头</div>
        <div class="studyPublish-content-info">
          由春阳台艺文中心和法国贾科梅蒂基金会共同举办的本次展览，从全新角度解读阿尔贝托·贾科梅蒂的艺术创作，探索他与建筑及空间的关系。贾科梅蒂对「纪念性」的追求将与塱头古村相遇，在这座拥有七百年历史的中国传统文化村落及其标志性新建筑春阳台里，开启一场有关古典与现代、东方与西方的对话。
          本次展览将聚焦于贾科梅蒂艺术创作的四个主要方面：从贾科梅蒂那间看似繁芜的工作室出发，审视其对待人形的建筑视角，对雕塑底座的执着，对“笼子”作为结构的迷恋，以及对空间与空白的玩味与控制。贾科梅蒂的作品也将与中国当代艺术家曾力的摄影作品和建筑师何健翔蒋滢夫妇的户外装置艺术进行对话。
        </div>
        <div class="studyPublish-content-info">
          1.
          二十世纪最伟大的雕塑家之一阿尔贝托·贾科梅蒂，他终其一生都选择在巴黎生活和创作。在中法建交60周年之际，阿尔贝托·贾科梅蒂的79件原作，将漂洋过海来到广州。这是时隔8年之后，贾科梅蒂的作品再次在中国展出。《1的纪念性：贾科梅蒂在塱头》是粤港澳大湾区第一次举办贾科梅蒂的大型展览，也是2024年亚洲地区的唯一一次公开展览活动。本次展出的所有作品均来自法国贾科梅蒂基金会，世界首屈一指的贾科梅蒂作品收藏机构。
        </div>
        <div class="studyPublish-content-info">
          2.
          这是贾科梅蒂第一个中西文化对话展，从全新角度解读他的艺术创作，并探索他与建筑及空间的关系。贾科梅蒂对“纪念性”的追求将与塱头古村相遇，在这座拥有七百年历史的中国传统文化村落及其标志性新建筑春阳台里，开启一场有关古典与现代、东方与西方的对话；
        </div>
        <div class="studyPublish-content-info">
          3.
          法国贾科梅蒂基金会历史上第一次中法联合策展：来自中国的建筑师张永和与贾科梅蒂基金会总监ÉMILIE
          BOUVARD联合策划，并邀请曾力、何健翔、蒋滢三位中国当代艺术家参与艺术对话；
        </div>
        <div class="studyPublish-content-info">
          4.
          本次展期超120天，春阳台将举行一系列高质量艺术对话交流活动，邀请世界级艺术家、学者与中国观众一起探讨古典与现代、东方与西方、城市发展与乡村振兴的对照与共融，开启一场粤港澳大湾区乃至国家级的艺术盛事。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "studyPublish",
  data() {
    return {
      donationList: [],
      pageList: [],
      currentIndex: 0,
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    pageIndex(val, oldval) {
      if (val !== oldval) {
        this.init();
      }
    },
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
      } else {
        this.init();
      }
    },
  },
  created() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
  },
  methods: {
    init() {},
  },
};
</script>
<style scoped>
.studyPublish {
  position: relative;
  margin-top: 5%;
  background-image: url(../../assets/publishBg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 1100px;
}
.studyPublish-title {
  position: absolute;
  top: 72px;
  left: 240px;
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.studyPublish-info {
  position: absolute;
  top: 160px;
  left: 240px;
  width: 100%;
  background-color: #fff;
  display: flex;
}
.studyPublish-pre-info {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  line-height: 22px;
  font-weight: 400;
}
.studyPublish-pre {
  width: 290px;
  height: 480px;
  margin: 70px 70px 0;
}
.studyPublish-pre-img {
  width: 290px;
  height: 400px;
  margin-bottom: 16px;
}
.studyPublish-content {
  width: 960px;
  margin-right: 63px;
  padding-bottom: 50px;
}
.studyPublish-content-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-top: 70px;
  margin-bottom: 50px;
}
.studyPublish-content-info {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: Regular;
  margin-bottom: 20px;
}
@media (max-width: 960px) {
}
@media (max-width: 768px) {
}
@media (max-width: 480px) {
}
</style>
